import Main from "./Main.js";
import Scene from "./Scene.js";
import Pqp from "../3x1010/Pqp.js";
export default class Wgallery {
	constructor(hs, parms, ct) {
		this.hs = hs;
		this.ct = ct;
		this.parms = parms;
		this.htocheck = new Array();
		this.startSlide = -1;
		this.videos = new Array();
		this.checkH = 0;
		this.startSlide = Pqp.isNullOrEmpty(parms.parm) ? -1 : parms.parm;
	}

	init() {
		Main.debugTrace("Hotspot Wgallery: " + this.hs.name);
		//Main.alert("ATTENZIONE!","Questo hotspot '"+this.hs.name+"' è di tipo 'gallery' ma la gallery non è ancora stata implementata.")
		this.gatherItems();
		jQuery(window).on("resize.gal", jQuery.proxy(this.precheckHtocheck, this));
	}

	gatherItems() {
		// In base al template recupera gli items
		let items;
		if (this.hs.template == Wgallery.T_STANDARD) {
			items = this.gatherFromIdGallery();
		} else if (this.hs.template == Wgallery.T_MULTIPLA) {
			items = this.gatherFromIdGallery();
		} else if (this.hs.template == Wgallery.T_POSTERS) {
			items = this.gatherFromIdGallery();
		} else {
			Main.alert("ATTENZIONE!", "Questo hotspot '" + this.hs.name + "' ha un tipo di template non riconosciuto: '" + this.hs.template + "'.");
			return
		}


		let lOk = true;
		for (var x = 0; x < items.length; x++) {
			if (items[x].type == Wgallery.ITEM_QUADRATO) {
				if (items[x].img == "") {
					//console.log(x)
					lOk = false;
					break;
				}
			}
			if (items[x].type == Wgallery.ITEM_HRETTANGOLO) {
				if (items[x].img == "") {
					//console.log(x)
					lOk = false;
					break;
				}
			}
			if (items[x].type == Wgallery.ITEM_YT) {
				if (items[x]["yt_" + Main.that.userLang.toLowerCase()] == "") {
					//console.log(x)
					lOk = false;
					break;
				}
			}
			if (items[x].type == Wgallery.ITEM_VRETTANGOLO) {
				if (items[x].img == "") {
					//console.log(x)
					lOk = false;
					break;
				}
			}

		}
		//console.log(lOk,x)
		if (!lOk) {
			Main.alert("ATTENZIONE!", "Questo hotspot '" + this.hs.name + "' dovrebbe aprire una gallery ma i dati per gestirla non sono stati inseriti correttamente sui fogli di google, indice nella gallery (parte da 0): " + x);
			return

		}

		if (items.length > 0) {
			this.buildGallery(items);
		} else {
			//console.log("uhm errore in gallery")
		}
	}


	gatherFromIdGallery() {
		let ret = new Array()
		let a = this.hs.InfoJson.iframe_url.split("§")
		console.log(this.hs.InfoJson.iframe_url)

		for (let x = 0; x < a.length; x++) {
			let o = {};
			o.type = Wgallery.ITEM_HRETTANGOLO;
			let tmp = a[x].split("|");
			let imag = tmp[0];
			if (imag.indexOf("[v]") >= 0) {
				o.type = Wgallery.ITEM_VRETTANGOLO;
				imag = Pqp.safeReplace(imag, "[v]", "");
			}
			if (imag.indexOf("[h]") >= 0) {
				o.type = Wgallery.ITEM_HRETTANGOLO;
				imag = Pqp.safeReplace(imag, "[h]", "");
			}
			o.img = imag;
			o.text = tmp[1];
			ret.push(o)
		}


		return ret;

		/*let items = new Array();
		let id = this.hs.gruppo;
		let a = SceneList.SCENE;
	
		for (let x = 0; x < a.length; x++) {
			let scene = a[x];
			if (scene.hotspots) {
				for (let y = 0; y < scene.hotspots.length; y++) {
					if (scene.hotspots[y].gruppo) {
						if (scene.hotspots[y].gruppo.toLowerCase() == id.toLowerCase()) {
							items.push(scene.hotspots[y]);
						}
					}
				}
			}
		}
		return items;*/

	}

	buildGallery(items) {

		Main.sfoca(true);
		Main.showInterface(false);
		let mc = jQuery("#template-trix-gallery").clone();
		mc.attr("id", "tgal" + Wgallery.ENUM++);
		jQuery(".js-trix1010").append(mc);
		this.mc = mc;
		for (let x = 0; x < items.length; x++) {
			if (items[x].name == this.hs.name) {
				if (this.startSlide == -1) {
					this.startSlide = x;
				}
			}
			if (items[x].type == Wgallery.ITEM_QUADRATO) {
				this.buildItemQuadrato(items[x]);
			}
			if (items[x].type == Wgallery.ITEM_HRETTANGOLO) {
				//this.buildItemHRettangolo(items[x]);
				this.buildItemOrizzontale(items[x]);
			}
			if (items[x].type == Wgallery.ITEM_YT) {
				this.buildItemYt(items[x], x);
			}
			if (items[x].type == Wgallery.ITEM_VRETTANGOLO) {
				//this.buildItemVRettangolo(items[x]);
				this.buildItemVerticale(items[x]);
			}

		}

		if (this.startSlide == -1) {
			this.startSlide = 0;
		}
		//Main.setUrl(Scene.getCurrentScene().name, this.hs.Uid + "|" + this.startSlide, null)

		jQuery(".js-close-frame", mc).on("click", jQuery.proxy(this.closeFrame, this));
		jQuery(".swiper-container", this.mc).addClass("je-suis-swiper")

		this.swiper = new Swiper('.je-suis-swiper', {
			navigation: {
				nextEl: '.swiper-btn-next',
				prevEl: '.swiper-btn-prev'
			},
			on: {
				"slideChange": jQuery.proxy(this.slideChanged, this)
			},
			initialSlide: this.startSlide,
			preloadImages: false,
			// Enable lazy loading
			lazy: true
		});
		//console.log(this.swiper)

		this.checkH = 0;
		clearTimeout(this.idcheck);
		this.idcheck = setTimeout(jQuery.proxy(this.checkHtocheck, this), 100);
		this.slideChanged();

	}

	slideChanged(e) {
		if (this.swiper) {
			//Main.setUrl(Scene.getCurrentScene().name, this.hs.Uid + "|" + this.swiper.activeIndex, null)
			jQuery(".to-remove", this.mc).remove();
			for (var x = 0; x < this.videos.length; x++) {
				if (this.videos[x].index == this.swiper.activeIndex) {
					this.createIFrame(this.videos[x].item, this.videos[x].clip)
				}
			}
		}
	}

	closeFrame(e) {
		jQuery(window).off("resize.gal");
		this.mc.remove();
		Main.showInterface(true);
		Main.sfoca(false);
		//Main.setUrl(Scene.getCurrentScene().name, null, null);
	}

	buildItemQuadrato(item) {
		let clip = jQuery("#template-item-gallery-quadrato").clone();
		clip.attr("id", "trix-item" + Wgallery.ENUM++);
		jQuery(".js-trix-panel", this.mc).append(clip);
		//jQuery(".js-image", clip).attr("data-background", "" + PLUNGE_SETTINGS.paths.BASE_URL + "assets/galleries/" + item.img);
		jQuery(".js-image", clip).attr("data-background", item.img);
		jQuery(".js-title-item", clip).html(item["title_" + Main.that.userLang.toLowerCase()]);
		jQuery(".js-desc-item", clip).html(item["desc_" + Main.that.userLang.toLowerCase()]);
	}

	buildItemHRettangolo(item) {
		let clip = jQuery("#template-item-gallery-hrettangolo").clone();
		clip.attr("id", "trix-item" + Wgallery.ENUM++);
		jQuery(".js-trix-panel", this.mc).append(clip);
		//jQuery(".js-image", clip).attr("data-background", "" + PLUNGE_SETTINGS.paths.BASE_URL + "assets/galleries/" + item.img);
		jQuery(".js-image", clip).attr("data-background", item.img);
		//console.log(item)
		let title = item["title_" + Main.that.userLang.toLowerCase()];
		let desc = item.text;// item["desc_" + Main.that.userLang.toLowerCase()];
		title = title ? title : "";
		desc = desc ? desc : "";

		if ((title == "") && (desc == "")) {
			jQuery(".js-wrapper-title-text", clip).hide();
		} else if ((title != "") && (desc != "")) {

		} else {
			jQuery(".js-divisore", clip).hide();
		}
		jQuery(".js-title-item", clip).html(title);
		jQuery(".js-desc-item", clip).html(desc);
	}

	buildItemYt(item, index) {
		let clip = jQuery("#template-item-gallery-yt").clone();
		clip.attr("id", "trix-item" + Wgallery.ENUM++);
		jQuery(".js-trix-panel", this.mc).append(clip);

		let title = item["title_" + Main.that.userLang.toLowerCase()];
		let desc = item.text;// item["desc_" + Main.that.userLang.toLowerCase()];
		if ((title == "") && (desc == "")) {
			jQuery(".js-wrapper-title-text", clip).hide();
		} else if ((title != "") && (desc != "")) {


		} else {
			jQuery(".js-divisore", clip).hide();
		}
		jQuery(".js-title-item", clip).html(title);
		jQuery(".js-desc-item", clip).html(desc);

		this.videos.push({
			index: index,
			clip: clip,
			item: item
		});
	}

	createIFrame(item, clip) {
		jQuery(".to-remove", this.mc).remove();
		let iframe = jQuery("<iframe class='trix-iframe-dim' width='100%' height='100%' src='' frameborder='0' allowfullscreen></iframe");
		iframe.attr("id", "ifrm" + Wyt.ENUM++);
		iframe.addClass("to-remove");
		jQuery(".yt-content", clip).append(iframe);
		var code = item["yt_" + Main.that.userLang.toLowerCase()]
		//var s = "//www.youtube.com/embed/";
		//iframe.attr("src", s + code + "?&cc_lang_pref=" + Main.that.userLang + "&cc_load_policy=1&hl=" + Main.that.userLang + "&color=white&autohide=0&iv_load_policy=3&autoplay=1&mute=1&rel=0&showinfo=0&controls=1&loop=1&playlist=" + code);
		let sy = Main.getYoutubeString(code)
		iframe.attr("src", sy);

		//console.log(iframe.attr("src"));
	}

	buildItemVRettangolo(item) {
		let clip = jQuery("#template-item-gallery-vrettangolo").clone();
		clip.attr("id", "trix-item" + Wgallery.ENUM++);
		jQuery(".js-trix-panel", this.mc).append(clip);
		this.htocheck.push(clip);
		//jQuery(".js-image",clip).css("background-image","url('"+PLUNGE_SETTINGS.paths.BASE_URL+"assets/galleries/"+ item.img+"')")
		//jQuery(".js-image", clip).attr("data-background", "" + PLUNGE_SETTINGS.paths.BASE_URL + "assets/galleries/" + item.img);
		jQuery(".js-image", clip).attr("data-background", item.img);
		//console.log(item["title_"+Main.that.userLang.toLowerCase()])
		jQuery(".js-desc-item", clip).html(item.text);

	}


	buildItemVerticale(item) {
		let clip = jQuery("#template-item-gallery-verticale").clone();
		clip.attr("id", "trix-item" + Wgallery.ENUM++);
		jQuery(".js-trix-panel", this.mc).append(clip);
		//this.htocheck.push(clip);
		//jQuery(".js-image",clip).css("background-image","url('"+PLUNGE_SETTINGS.paths.BASE_URL+"assets/galleries/"+ item.img+"')")
		//jQuery(".js-image", clip).attr("data-background", "" + PLUNGE_SETTINGS.paths.BASE_URL + "assets/galleries/" + item.img);
		jQuery(".js-image", clip).attr("data-background", item.img);
		//console.log(item["title_"+Main.that.userLang.toLowerCase()])
		jQuery(".title-item", clip).html(item.text);

	}

	buildItemOrizzontale(item) {
		let clip = jQuery("#template-item-gallery-orizzontale").clone();
		clip.attr("id", "trix-item" + Wgallery.ENUM++);
		jQuery(".js-trix-panel", this.mc).append(clip);
		//this.htocheck.push(clip);
		//jQuery(".js-image",clip).css("background-image","url('"+PLUNGE_SETTINGS.paths.BASE_URL+"assets/galleries/"+ item.img+"')")
		//jQuery(".js-image", clip).attr("data-background", "" + PLUNGE_SETTINGS.paths.BASE_URL + "assets/galleries/" + item.img);
		jQuery(".js-image", clip).attr("data-background", item.img);
		//console.log(item["title_"+Main.that.userLang.toLowerCase()])
		jQuery(".title-item", clip).html(item.text);

	}


	precheckHtocheck() {
		clearTimeout(this.idres);
		this.idres = setTimeout(jQuery.proxy(this.checkHtocheck, this), 100)
	}
	checkHtocheck(item) {
		//	console.log("CHECK")
		let a = this.htocheck;
		for (var x = 0; x < a.length; x++) {
			this.fith(a[x])
		}
		clearTimeout(this.idcheck);
		if (this.checkH < 3) {
			this.checkH++;
			this.idcheck = setTimeout(jQuery.proxy(this.checkHtocheck, this), 200);
		}

	}

	fith(clipCont) {
		let lCondExit = false;
		let safe = 0;
		let w = 25;
		if (jQuery(window).width() < 1024) {
			w = 28;
		}
		let clip = jQuery(".js-item-height", clipCont);
	
		while (!lCondExit) {
			clip.css("width", w + "%");
			if (clip.height() > jQuery(".js-trix1010").height()) {
				w--;
			} else {
				lCondExit = true;
			}
			safe++;
			if (safe == 30) {
				lCondExit = true;
			}
		}
		console.log(w)
		let h = jQuery(".js-trix1010").height();
		let pad = (h - clip.height()) / 2;
		clip.css("padding-top",pad)


	}
}

Wgallery.ENUM = 0;
Wgallery.T_STANDARD = "standard";
Wgallery.T_MULTIPLA = "multipla";
Wgallery.T_POSTERS = "poster";

Wgallery.ITEM_QUADRATO = "quadrato";
Wgallery.ITEM_HRETTANGOLO = "hrettangolo";
Wgallery.ITEM_YT = "yt";
Wgallery.ITEM_VRETTANGOLO = "vrettangolo";
